import React, { useState } from "react";
import CustomModalLayout from "../../../../../web/Auth/CustomModalLayout";

interface JBNameMismatchModalProps {
  open: boolean;
  setOpen: any;
  profileName: string;
  kycName: string;
  handleRetryKycRequest: () => void;
  mismatchType?: string;
  handleOfflineModeSwitch: () => void;
}

export default function JBNameMismatchModal({
  open,
  setOpen,
  profileName,
  kycName,
  handleRetryKycRequest,
  mismatchType,
  handleOfflineModeSwitch,
}: JBNameMismatchModalProps) {
  const isOfflineModeEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_JOINT_INDIVIDUALS_KYC !== "true";
  return (
    <CustomModalLayout
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[380px]">
        <div className="flex flex-col gap-3">
          <div className="font-semibold text-lg text-brand-textBlack text-center">
            Name Mismatch Detected ({mismatchType})
          </div>
          <div className="text-xs text-brand-textGrey text-center">
            Your profile name does not match the name on your official documents
            submitted for the auction participation request.
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-lg font-semibold text-brand-textBlack">
              Profile Name
            </div>
            <div className="text-lg font-semibold text-brand-orange">
              {profileName}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-lg font-semibold text-brand-textBlack">
              Name As per Document
            </div>
            <div className="text-lg font-semibold text-green-600">
              {kycName}
            </div>
          </div>
        </div>
        <div>
          <div className="font-openSans text-xs text-center mb-3">
            Your profile name has been verified through PAN and cannot be
            updated directly. However, we have detected a mismatch between your
            profile name and your documents. Please contact Auction Bazaar
            support to request a correction.
          </div>
          {isOfflineModeEnabled && (
            <div className="flex flex-col items-center gap-2 mt-2 pt-2 pb-4 border-t border-brand-borderLightGray">
              <p className="text-xs text-brand-textBlack text-center leading-4">
                To continue with name mismatch, switch to offline mode.
                You&apos;ll need to submit KYC documents at the bank for
                verification.
              </p>
              <span
                className="flex justify-center text-[#1C64F2] underline cursor-pointer font-medium text-xs mt-2"
                onClick={handleOfflineModeSwitch}
              >
                Switch to Offline Verification
              </span>
            </div>
          )}
          <div className="font-openSans text-xs text-center">
            Entered incorrect details?
          </div>
          <div
            onClick={handleRetryKycRequest}
            className="flex justify-center text-[#1C64F2] underline cursor-pointer font-medium text-xs mt-2"
          >
            Discard Application and Start Over
          </div>
        </div>
      </div>
    </CustomModalLayout>
  );
}
